import React, { useEffect, useState } from 'react';
import { about5, heroVideo, arashBg, aboutBg, subMenuProjects, subMenuHome, subMenuPartners } from '../../assets/images';
import Header from '../../Components/Header/Header';
import SetemDetailItems from './SetemDetailItems/SetemDetailItems';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Breadcrumb from '../../Components/Breadcrumb/Breadcrumb';

const newsItems = [
  {
    id: 1,
    imgSrc: subMenuHome,
    title: 'İsitmə',
    description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
  },
  {
    id: 2,
    imgSrc: subMenuPartners,
    title: 'Ventilyasiya',
    description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
  },
  {
    id: 3,
    imgSrc: subMenuProjects,
    title: 'Soyutma, kondisionerləşdirmə',
    description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
  },
  {
      id: 4,
      imgSrc: subMenuHome,
      title: 'Santexnika',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
    },
    {
      id: 5,
      imgSrc: subMenuPartners,
      title: 'Yanğınsöndürmə',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
    },
    {
      id: 6,
      imgSrc: subMenuProjects,
      title: 'Elektrik sistemləri',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
    },
    {
      id: 7,
      imgSrc: subMenuHome,
      title: 'Aşağı cərəyan',
       description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
    },
    {
      id: 8,
      imgSrc: subMenuPartners,
      title: 'Avtomatlaşdırma sistemləri',
       description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
    },
    {
      id: 9,
      imgSrc: subMenuProjects,
      title: 'Kanal sexi',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
    },
];

const SetemDetail = () => {


   const { t } = useTranslation();
  
        const { id } = useParams();
  
        const [singleNews, setSingleNews] = useState("")
  
        useEffect(() => {
  
  
          const filteredTour = newsItems.find(product => product.id == id);
          setSingleNews(filteredTour);
      
        }, []);

  return (
    <>
      <div
        className='bg-black/60'
        style={{
          position: 'relative',
          overflow: 'hidden',
          backgroundImage: `url(${aboutBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          width: '100%',
          height: window.innerWidth < 640 ? '250px' : '300px',
        }}
      >
        <Breadcrumb title={t("SƏTƏM")} content={singleNews.title}/>

      </div>

      <SetemDetailItems/>
    </>
  );
};

export default SetemDetail;
